var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.73 148.457V248.81l91.589 52.885V195.891L28.08 143.224a39.358 39.358 0 0 0-.35 5.233zM149.319 319.018 241 371.955V266.131l-91.681-52.923zM256 134.326l-91.667 52.909L256 240.15l91.667-52.915zM271 371.955l91.681-52.937v-105.81L271 266.131zM483.919 143.224l-91.239 52.667v105.804l91.589-52.885V148.457a39.024 39.024 0 0 0-.35-5.233zM464.539 114.271a398158.434 398158.434 0 0 0-86.865-50.175l-91.668 52.91 91.666 52.909 91.273-52.687a39.2 39.2 0 0 0-4.406-2.957zM347.673 46.774a190699.539 190699.539 0 0 0-71.925-41.509A39.535 39.535 0 0 0 256.001 0a39.54 39.54 0 0 0-19.752 5.267 193040.748 193040.748 0 0 1-71.902 41.518L256 99.687zM134.342 64.105c-32.938 19.013-65.136 37.6-86.866 50.157a39.175 39.175 0 0 0-4.419 2.968l91.271 52.686 91.666-52.909zM27.73 366.482c0 14.073 7.561 27.172 19.731 34.187l.015.009c18.407 10.636 44.326 25.601 71.843 41.485V336.337L27.73 283.452zM149.319 459.48c32.965 19.029 65.197 37.635 86.944 50.201A39.276 39.276 0 0 0 241 512V406.597l-91.681-52.938zM271 511.998a39.133 39.133 0 0 0 4.751-2.325c22.261-12.839 54.378-31.377 86.929-50.172V353.659L271 406.597zM392.681 442.177c27.952-16.142 54.009-31.194 71.843-41.5 12.186-7.023 19.747-20.123 19.747-34.195v-83.031l-91.589 52.885v105.841z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviders);
export default __webpack_public_path__ + "static/media/providers.9a886093aa9e64891650ff50768ba86f.svg";
export { ForwardRef as ReactComponent };